import React from "react";

import { observer } from "mobx-react-lite";

import { ExpressionNode } from "@/components/expression/ExpressionNode";
import { NodeStyleProvider } from "@/components/expression/utils/NodeStyleProvider";

import type { NodeWithUnit } from "./types";

type Props = {
  nodes: NodeWithUnit[];
};

export const UnitPreviewNodes = observer(function UnitPreviewNodes({ nodes }: Props) {
  if (nodes.length === 0) {
    return null;
  }

  return (
    <NodeStyleProvider text="default" view="expression" renderContext="right-sidebar">
      <div className="flex items-baseline gap-2">
        {nodes.map((node, index) => {
          return (
            <React.Fragment key={node.id}>
              <ExpressionNode node={node} />
              {index !== nodes.length - 1 && <span className="text-gray-400">,</span>}
            </React.Fragment>
          );
        })}
      </div>
    </NodeStyleProvider>
  );
});
